import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CardSkeleton = () => {
    return (
        <div className="w-[970px]">
            {[0, 1].map((row) => (
                <div key={row} className="flex mb-[30px]">
                    {[0, 1, 2].map((col) => {
                        const index = row * 3 + col;
                        return (
                            <div
                                key={index}
                                className="w-[285px]"
                                style={{ marginRight: col < 2 ? "30px" : "0" }}
                            >
                                <Skeleton height={90} />
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default CardSkeleton;
